import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PriceRobotFilter} from "../services/price-robot-filter";
import {Category, VariantGroup} from "@hassel-it/shop-services";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {PriceRobotReport} from "../services/price-robot-report";
import {PriceRobotReportsService} from "../services/price-robot-reports.service";
import {IDropdownSettings} from "ng-multiselect-dropdown";
import {forEach} from "lodash";
import {PriceRobotProductsService} from "../services/price-robot-products.service";

@Component({
    providers: [PriceRobotReportsService],
    selector: 'app-price-robot-filter-box',
    templateUrl: './price-robot-filter-box.component.html',
    styleUrls: ['./price-robot-filter-box.component.scss']
})
export class PriceRobotFilterBoxComponent implements OnInit {
    @Input() filter: PriceRobotFilter = new PriceRobotFilter();
    @Input() users: any;
    @Input() variantGroups: VariantGroup[];
    @Input() categories: Category[];
    @Input() page: string = '';
    @Output() refresh: EventEmitter<any> = new EventEmitter<any>();
    @Output() updatedFilter: EventEmitter<PriceRobotFilter> = new EventEmitter<PriceRobotFilter>();
    public changed: boolean = false;
    public modal: NgbModalRef;
    public previousFilter = new PriceRobotFilter();

    saving = false;

    dropdownSettings: IDropdownSettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'name',
        limitSelection: 3,
        allowSearchFilter: true,
        enableCheckAll: false
    };
    variantSettings: IDropdownSettings = {
        singleSelection: true,
        idField: 'id',
        textField: 'name',
        allowSearchFilter: true,
        enableCheckAll: false
    };

    report: PriceRobotReport;
    reports: PriceRobotReport[];

    editingReport: PriceRobotReport | null;

    constructor(private modalService: NgbModal,
                private priceRobotProductsApiService: PriceRobotProductsService,
                private priceRobotReportsService: PriceRobotReportsService) {
    }

    ngOnInit(): void {
    }

    refreshParent() {
        this.refresh.emit(1);
    }

    toggleActive(report: PriceRobotReport) {
        report.is_active = !report.is_active;
    }

    toggleReportEditable(report: PriceRobotReport | null) {
        this.editingReport = report;
    }

    saveReportWithoutAssociations(report: PriceRobotReport) {
        this.saving = true;

        this.priceRobotReportsService.updatePriceRobotReport(report).then((result) => {
            this.loadReports();

            this.saving = false;
            this.editingReport = null;
        });
    }

    changedcategorySelect($event) {
        const newIds = [];
        this.filter.selectedCategories.forEach((item) => {
            newIds.push(item.id);
        })
        this.filter.categoryIds = newIds;
    }

    changedVarintSelect($event) {
        const newIds = [];
        for (const key in this.filter.selectedVariants) {
            if (this.filter.selectedVariants.hasOwnProperty(key) && this.filter.selectedVariants[key] !== null && this.filter.selectedVariants[key] !== '') {
                newIds.push(this.filter.selectedVariants[key]);
            }
        }
        /**
         * Replace multiselect object with just the id
         */
        let i = 0;
        newIds.forEach((newId) => {
            if (newId !== undefined && newId.length > 0) {
                newIds[i] = newId[0].id
            }
            i++;
        })
        this.filter.variantIds = newIds;
    }

    resetVariants() {
        this.filter.selectedVariants = {};
    }

    resetFilter() {
        this.filter = new PriceRobotFilter();
        this.previousFilter = new PriceRobotFilter();
        this.changed = false;
    }

    loadReports() {
        this.priceRobotReportsService.getReports(1, {}).then(result => {
            this.reports = result.results;
        });
    }

    startGetConditions(modalContent: any) {
        this.loadReports();
        this.modal = this.modalService.open(modalContent, {size: 'lg'});
    }

    startSaveConditions(modalContent: any) {
        this.report = new PriceRobotReport();
        this.report.name = '';
        this.report.users = [];

        this.modal = this.modalService.open(modalContent);
    }

    saveReport() {
        this.report.conditions_data = this.filter;
        this.report.conditions_query = this.priceRobotProductsApiService.buildQuery(this.filter).toString();

        for (let i = this.report.users.length - 1; i >= 0; i--) {
            if (!this.report.users[i].id) {
                this.report.users.splice(i, 1);
            }
        }

        this.priceRobotReportsService.createPriceRobotReport(this.report).then((result) => {
            this.modal.close();
            this.loadReports();
        });
    }

    deleteReport(report: PriceRobotReport) {
        this.priceRobotReportsService.deletePriceRobotReport(report).then(result => {
            this.loadReports();
        })
    }

    loadReport(report: PriceRobotReport) {
        this.filter = report.conditions_data;
        this.modal.close();
        this.updatedFilter.emit(this.filter);
    }
}

